import React from 'react';

const BottomSheet = (props) => {
  const { opened } = props;
  return (
    <div className={`bottomsheet d-flex d-lg-none ${opened ? 'opened' : ''}`}>
      <div className="bottomsheet-container">{props.children}</div>;
    </div>
  );
};

export default BottomSheet;
